import React, { forwardRef, Ref } from 'react';
import AppTextField from '../../designe/app-text-field/AppTextField';

import { IconButton, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';

import clsx from 'clsx';
import { useStyles } from './Search.styles';
import theme from '../../../styles/theme';
import { BaseTextFieldProps } from '@mui/material/TextField/TextField';

interface IAppSearchProps extends BaseTextFieldProps {
  onChange?: (value: any) => void;
  InputProps?: any;
}

const Search = forwardRef(
  (props: IAppSearchProps, ref?: Ref<HTMLDivElement>) => {
    const { onChange, className, value, ...otherProps } = props;
    const { classes } = useStyles(theme);

    return (
      <AppTextField
        {...otherProps}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={clsx(classes.searchInput, className)}
        ref={ref}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon classes={{ root: 'search-icon' }} />
            </InputAdornment>
          ),
          endAdornment: value ? (
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={() => onChange('')}
                edge="end"
                size="large">
                <CloseIcon />
              </IconButton>
            </InputAdornment>
          ) : null,
        }}
      />
    );
  },
);

export default Search;
